import { useEffect } from "react";
import type { HttpAgent } from "@ag-ui/client";

import { ConversationNameMiddleware } from "./ConversationNameMiddleware";

/**
 * Wires a `ConversationNameMiddleware` into the agent so that
 * `conversation_name` CustomEvents are extracted before the AG-UI verifier
 * sees them and routed to `onConversationName`.
 *
 * `onConversationName` must be stable (e.g. `useCallback`) — AG-UI has no
 * `unuse`, so re-running this effect would leak duplicate middleware. The
 * agent itself is mount-scoped (created with `useMemo([conversationId])`),
 * so the middleware lives exactly as long as the agent.
 */
export function useConversationName(
  agent: HttpAgent,
  onConversationName: (conversationId: string, displayName: string) => void
): void {
  useEffect(() => {
    agent.use(new ConversationNameMiddleware(onConversationName));
  }, [agent, onConversationName]);
}
